<template>
  <section class="content-wrapper">
    <columns>
      <column size="is-9">
       <margin-title :title="title" :subtitle="subtitle" />
        <slot name="left"></slot>
      </column>
      <column size="is-3">
        <slot name="right"></slot>
      </column>
    </columns>
  </section>
</template>

<script>
import Container from '@/components/general/container'
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'
import MarginTitle from '@/components/margin-title'

export default {
  components: {
    Container,
    Columns,
    Column,
    MarginTitle
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Settings'
    },
    subtitle: {
      type: String,
      required: true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/templates/setting-template.vue